module.exports = __webpack_public_path__ + "img/4000x2250-oscuro.f6218276.jpg";